import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
} from "../Services/Urls";

import { callApi, makeApiRequest } from "../Services/ApiService";
import { decryptOtp } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { getRecords, PostRecords } from "../Services/ApiCall";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import Footer from "../Common/Footer";
import Header from "../Common/Header";

import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";

import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";

import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";

function SidebarFilter({ filters, tabID, onChange }) {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,
    setCityData,
    vertical,
    setVertical,
    properType,
    setproperType,
    coordinates,
    setcoordinates,
    BHKData,
    setBHKData,
    Locality,
    setLocality,
    Area,
    setArea,
    Projects,
    setProjects,
    searchData,
    setsearchData,

    FurnishType,
    setFurnishType,
    societyAmenities,
    setSocietyAmenities,
    constructionStatus,
    setConstructionStatus,
    propertyAmenities,
    setPropertyAmenities,
    roomConfig,
    setRoomConfig,
    Meals,
    setMeals,
    CommonArea,
    setCommonArea,
    PGisFor,
    setPGisFor,
    bestSuitFor,
    setBestSuitFor,
    selected_FurnishType,
    setSelectedFurnishType,
    selected_societyAmenities,
    setSelectedSocietyAmenities,
    selected_constructionStatus,
    setSelectedConstructionStatus,
    selected_propertyAmenities,
    setSelectedPropertyAmenities,
    selected_roomConfig,
    setSelectedRoomConfig,
    selected_Meals,
    setSelectedMeals,
    selected_CommonArea,
    setSelectedCommonArea,
    selected_PGisFor,
    setSelectedPGisFor,
    selected_bestSuitFor,
    setSelectedBestSuitFor,
    selected_vertical,
    setSelectedVertical,
    selected_properType,
    setSelectedProperType,
    selected_BHKData,
    setSelectedBHKData,
  } = useContext(ApiContext);

  const [ChooseProperty, setChooseProperty] = useState([]);
  const [Selected_ChooseProperty, setSelectedChooseProperty] = useState([]);

  const [PostedByData, setPostedByData] = useState([
    { id: 1, name: "Owner", colorCode: "#000000" },
    { id: 2, name: "Agent", colorCode: "#000000" },
  ]);

  const [Selected_PostedByData, setSelectedPostedByData] = useState(null);

  const [showAllchooseproptype, setShowAllchooseproptype] = useState(false);
  const [showAllunitfurnish, setShowAllunitfurnish] = useState(false);
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  const [showAllBHK, setShowAllBHK] = useState(false);

  const [MinBudget, setMinBudget] = useState("");
  const [MaxBudget, setMaxBudget] = useState("");

  const VISIBLE_COUNT = 5;
  const visibleChooseProperty = showAllchooseproptype
    ? ChooseProperty
    : ChooseProperty?.slice(0, VISIBLE_COUNT);

  const visibleUnitFurnishing = showAllunitfurnish
    ? propertyAmenities
    : propertyAmenities?.slice(0, VISIBLE_COUNT);

  const visibleAmenities = showAllAmenities
    ? societyAmenities
    : societyAmenities?.slice(0, VISIBLE_COUNT);

  const visibleBHK = showAllBHK ? BHKData : BHKData?.slice(0, VISIBLE_COUNT);

  useEffect(() => {
    if (vertical.length === 0) {
      getVerticalType();
    }

    if (properType.length === 0) {
      getPropertyType();
    }

    if (BHKData.length === 0) {
      getBHKType();
    }

    if (FurnishType.length === 0) {
      getFurnishType();
    }

    if (societyAmenities.length === 0) {
      getSocietyAmenities();
    }

    if (constructionStatus.length === 0) {
      getConstructionStatus();
    }

    if (propertyAmenities?.length === 0) {
      getpropertyAmenities();
    }

    if (filters?.vertical === 3) {
      if (roomConfig?.length === 0) {
        getRoomConfig();
      }

      if (Meals?.length === 0) {
        getMeals();
      }

      if (CommonArea?.length === 0) {
        getCommonArea();
      }
    }

    if (ChooseProperty?.length === 0) {
      getChoosePropertyType();
    }
  }, []);

  const getChoosePropertyType = () => {
    getRecords(
      411,
      100,
      `{PropertyTypeID: { $in: [${filters?.propertyType}] },VerticalID: { $in: [${filters?.vertical}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setChooseProperty(data?.response?.records || []);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const getPropertyType = () => {
    getRecords(391, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setproperType(data?.response?.records || []);

          if (tabID != null) {
            const records = data?.response?.records || [];
            const selected =
              tabID == 384 || tabID == 385 || tabID == 386
                ? records.find((x) => x.PropertyTypeID === 1)
                : records.find((x) => x.PropertyTypeID === 2);

            setSelectedProperType(selected || null);
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getVerticalType = () => {
    getRecords(392, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setVertical(data?.response?.records || []);
        //  debugger;
          if (tabID != null) {
            const records = data?.response?.records || [];

            const selected =
              tabID == 384 || tabID == 387
                ? records?.find((x) => x.VerticalID === 1)
                : tabID == 385 || tabID == 388
                  ? records?.find((x) => x.VerticalID === 2)
                  : tabID == 386
                    ? records?.find((x) => x.VerticalID === 3)
                    : records?.find((x) => x.VerticalID === 1);

            setSelectedVertical(selected || null); // ✅ correct setter
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getBHKType = () => {
    getRecords(394, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setBHKData(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getFurnishType = () => {
    getRecords(395, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setFurnishType(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getSocietyAmenities = () => {
    getRecords(396, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setSocietyAmenities(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConstructionStatus = () => {
    getRecords(406, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setConstructionStatus(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getpropertyAmenities = () => {
    getRecords(397, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyAmenities(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getRoomConfig = () => {
    getRecords(421, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setRoomConfig(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getMeals = () => {
    getRecords(422, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setMeals(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getCommonArea = () => {
    getRecords(423, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setCommonArea(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  //  console.log("Selected Filters in SidebarFilter:", selected_vertical);

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-widget style4">
          <div className="d-flexx">
            <h6 className="d-desk">Filters</h6>
            <a
              onClick={() => {

                setSelectedChooseProperty([]);
                Selected_PostedByData(null);
                setSelectedBHKData([]);
                setSelectedConstructionStatus([]);
                setSelectedFurnishType([]);
                setSelectedSocietyAmenities([]);
                setSelectedPropertyAmenities([]);
                setSelectedRoomConfig([]);
                setSelectedMeals([]);
                setSelectedCommonArea([]);
                setMinBudget("");
                setMaxBudget("");


                



                onChange(() => ({
                  propertyType: 1,
                  vertical: 1,

                  status: 2,
                }));
              }}
            >
              Clear All
            </a>
          </div>
          <div className="fblock">
            <strong>Property Type</strong>
            {properType?.filter((x) => x.PropertyTypeID === 1) ?.map((type, index) => (
              <div className="d-block" key={index}>
                <input
                  type="radio"
                  id={type.PropertyTypeID}
                  checked={
                    selected_properType?.PropertyTypeID === type.PropertyTypeID
                  }
                  onChange={() => {
                    setSelectedProperType(type); // ✅ set object directly

                    onChange((filtersPrev) => ({
                      ...filtersPrev,
                      propertyType: type.PropertyTypeID, // ✅ dynamic
                    }));
                  }}
                />
                <label htmlFor={`choice${index}`}>{type?.PropertyType}</label>
              </div>
            ))}

            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Looking For</strong>
         {[...(vertical || [])]
                    .filter((btn) => {
                      
                     if(btn?.VerticalID == 2 || btn?.VerticalID == 1) return true
                    
                    })
                    .reverse()?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="radio"
                  checked={selected_vertical?.VerticalID === type.VerticalID}
                  onChange={() => {
                    setSelectedVertical(type); // ✅ set object directly

                    onChange((filtersPrev) => ({
                      ...filtersPrev,
                      vertical: type.VerticalID, // ✅ dynamic
                    }));
                  }}
                />
                <label htmlFor="buy">{type?.Vertical}</label>
              </div>
            ))}

            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Posted By</strong>
            {PostedByData?.map((type, index) => (
              <div className="d-block" key={index}>
                <input
                  type="radio"
                  id={type.id}
                  checked={Selected_PostedByData?.id === type.id}
                  onChange={() => {
                    setSelectedPostedByData(type); // ✅ set object directly

                    onChange((filtersPrev) => ({
                      ...filtersPrev,
                      postedBy: type.id, // ✅ dynamic
                    }));
                  }}
                />
                <label htmlFor={`choice${index}`}>{type?.name}</label>
              </div>
            ))}

            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Property Type</strong>
            {visibleChooseProperty?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.ChoosePropertyID}
                  checked={Selected_ChooseProperty.some(
                    (v) => v.ChoosePropertyID === type.ChoosePropertyID,
                  )}
                  onChange={() => {
                    setSelectedChooseProperty((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.ChoosePropertyID === type.ChoosePropertyID,
                      )
                        ? prev.filter(
                            (v) => v.ChoosePropertyID !== type.ChoosePropertyID,
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        propertyTypeIds: nextSelected.map(
                          (item) => item.ChoosePropertyID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.ChooseProperty}>
                  {type?.ChooseProperty}
                </label>
              </div>
            ))}

            <a
              style={{ cursor: "pointer", color: "#1e88e5" }}
              onClick={() => setShowAllchooseproptype((prev) => !prev)}
            >
              {showAllchooseproptype ? "View Less" : "View More"}
            </a>
          </div>

          {filters?.propertyType === 1 &&
            (filters?.vertical === 1 || filters?.vertical === 2) && (
              <div className="fblock">
                <strong>No. of Rooms</strong>
                {visibleBHK?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.BHKID}
                      checked={selected_BHKData.some(
                        (v) => v.BHKID === type.BHKID,
                      )}
                      onChange={() => {
                        setSelectedBHKData((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.BHKID === type.BHKID,
                          )
                            ? prev.filter((v) => v.BHKID !== type.BHKID) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            bhkTypeIds: nextSelected.map((item) => item.BHKID),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.BHKUnit}>{type?.BHKUnit}</label>
                  </div>
                ))}

                <a
                  style={{ cursor: "pointer", color: "#1e88e5" }}
                  onClick={() => setShowAllBHK((prev) => !prev)}
                >
                  {showAllchooseproptype ? "View Less" : "View More"}
                </a>
              </div>

              /* your additional condition here */
            )}

          <div className="fblock">
            <strong>Construction Status</strong>
            {constructionStatus?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.ConstructionStatusID}
                  checked={selected_constructionStatus.some(
                    (v) => v.ConstructionStatusID === type.ConstructionStatusID,
                  )}
                  onChange={() => {
                    setSelectedConstructionStatus((prev) => {
                      const nextSelected = prev.some(
                        (v) =>
                          v.ConstructionStatusID === type.ConstructionStatusID,
                      )
                        ? prev.filter(
                            (v) =>
                              v.ConstructionStatusID !==
                              type.ConstructionStatusID,
                          ) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        constructionStatusIds: nextSelected.map(
                          (item) => item.ConstructionStatusID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.ConstructionStatus}>
                  {type?.ConstructionStatus}
                </label>
              </div>
            ))}

            {/* <a href="#">View More</a> */}
          </div>

          <div className="fblock">
            <strong>Furnish Type</strong>
            {FurnishType?.map((type, index) => (
              <div key={index} className="d-block">
                <input
                  type="checkbox"
                  id={type.FurnishID}
                  checked={selected_FurnishType.some(
                    (v) => v.FurnishID === type.FurnishID,
                  )}
                  onChange={() => {
                    setSelectedFurnishType((prev) => {
                      const nextSelected = prev.some(
                        (v) => v.FurnishID === type.FurnishID,
                      )
                        ? prev.filter((v) => v.FurnishID !== type.FurnishID) // remove
                        : [...prev, type]; // add object

                      // 🔑 update filters using the SAME derived data
                      onChange((filtersPrev) => ({
                        ...filtersPrev,
                        furnishingTypeIds: nextSelected.map(
                          (item) => item.FurnishID,
                        ),
                      }));

                      return nextSelected;
                    });
                  }}
                />
                <label htmlFor={type?.FurnishType}>{type?.FurnishType}</label>
              </div>
            ))}

            {/* <a href="#">View More</a> */}
          </div>

          {filters?.propertyType === 1 && filters?.vertical === 3 && (
            <>
              <div className="fblock">
                <strong>PG Is For</strong>
                {PGisFor?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.name}
                      checked={selected_PGisFor.some((v) => v.id === type.id)}
                      onChange={() => {
                        setSelectedPGisFor((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.id === type.id,
                          )
                            ? prev.filter((v) => v.id !== type.id) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            PGisFor: nextSelected.map((item) => item.id),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.name}>{type?.name}</label>
                  </div>
                ))}

                <a href="#">View More</a>
              </div>

              <div className="fblock">
                <strong>Best Suited For</strong>
                {bestSuitFor?.map((type, index) => (
                  <div key={index} className="d-block">
                    <input
                      type="checkbox"
                      id={type.name}
                      checked={selected_bestSuitFor.some(
                        (v) => v.id === type.id,
                      )}
                      onChange={() => {
                        setSelectedBestSuitFor((prev) => {
                          const nextSelected = prev.some(
                            (v) => v.id === type.id,
                          )
                            ? prev.filter((v) => v.id !== type.id) // remove
                            : [...prev, type]; // add object

                          // 🔑 update filters using the SAME derived data
                          onChange((filtersPrev) => ({
                            ...filtersPrev,
                            BestSuitedFor: nextSelected.map((item) => item.id),
                          }));

                          return nextSelected;
                        });
                      }}
                    />
                    <label htmlFor={type?.name}>{type?.name}</label>
                  </div>
                ))}
                <a href="#">View More</a>
              </div>
            </>
          )}

          <div className="fblock">
            <strong>Budget</strong>
            <div style={{ marginTop: 4 }} className="d-block">
              <div className="form-group">
                <input
                  value={MinBudget}
                  onChange={(e) => {
                    setMinBudget(e.target.value);
                  }}
                  type="text"
                  placeholder="Min"
                />
              </div>
            </div>
            <div className="d-block">
              <div className="form-group">
                <input
                  value={MaxBudget}
                  onChange={(e) => {
                    setMaxBudget(e.target.value);
                  }}
                  type="text"
                  placeholder="Max"
                />
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <button
                disabled={!MinBudget && !MaxBudget}
                style={{
                  width: "85%",
                  backgroundColor:
                    !MinBudget && !MaxBudget ? "#9ca3af" : "#16a34a", // disabled / active color
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  padding: "5px 5px",
                  cursor: !MinBudget && !MaxBudget ? "not-allowed" : "pointer",
                  fontWeight: "400",
                  marginTop: "3px",
                  transition: "0.2s ease",
                  opacity: !MinBudget && !MaxBudget ? 0.7 : 1,
                }}
                onMouseOver={(e) => {
                  if (MinBudget && MaxBudget) {
                    e.target.style.backgroundColor = "#15803d";
                  }
                }}
                onMouseOut={(e) => {
                  if (MinBudget && MaxBudget) {
                    e.target.style.backgroundColor = "#16a34a";
                  }
                }}
                onClick={() => {
                  onChange((filtersPrev) => ({
                    ...filtersPrev,
                    MinPrice: MinBudget,
                    MaxPrice: MaxBudget,
                  }));
                }}
              >
                Apply
              </button>
            </div>
          </div>

          {filters?.propertyType === 1 &&
            (filters?.vertical === 1 || filters?.vertical === 2) && (
              <>
                <div className="fblock">
                  <strong>Society Amenities</strong>
                  {visibleAmenities?.map((type, index) => (
                    <div key={index} className="d-block">
                      <input
                        type="checkbox"
                        id={type.PropertyAmenitiesID}
                        checked={selected_societyAmenities.some(
                          (v) =>
                            v.PropertyAmenitiesID === type.PropertyAmenitiesID,
                        )}
                        onChange={() => {
                          setSelectedSocietyAmenities((prev) => {
                            const nextSelected = prev.some(
                              (v) =>
                                v.PropertyAmenitiesID ===
                                type.PropertyAmenitiesID,
                            )
                              ? prev.filter(
                                  (v) =>
                                    v.PropertyAmenitiesID !==
                                    type.PropertyAmenitiesID,
                                ) // remove
                              : [...prev, type]; // add object

                            // 🔑 update filters using the SAME derived data
                            onChange((filtersPrev) => ({
                              ...filtersPrev,
                              societyAmenities: nextSelected.map(
                                (item) => item.PropertyAmenitiesID,
                              ),
                            }));

                            return nextSelected;
                          });
                        }}
                      />
                      <label htmlFor="Lift">{type?.PropertyAmenities}</label>
                    </div>
                  ))}
                  <a
                    style={{ cursor: "pointer", color: "#1e88e5" }}
                    onClick={() => setShowAllAmenities((prev) => !prev)}
                  >
                    {showAllAmenities ? "View Less" : "View More"}
                  </a>
                </div>

                <div className="fblock">
                  <strong>Property Furnishings</strong>
                  {visibleUnitFurnishing?.map((type, index) => (
                    <div key={index} className="d-block">
                      <input
                        type="checkbox"
                        id={type.UnitFurnishingID}
                        checked={selected_propertyAmenities.some(
                          (v) => v.UnitFurnishingID === type.UnitFurnishingID,
                        )}
                        onChange={() => {
                          setSelectedPropertyAmenities((prev) => {
                            const nextSelected = prev.some(
                              (v) =>
                                v.UnitFurnishingID === type.UnitFurnishingID,
                            )
                              ? prev.filter(
                                  (v) =>
                                    v.UnitFurnishingID !==
                                    type.UnitFurnishingID,
                                ) // remove
                              : [...prev, type]; // add object

                            // 🔑 update filters using the SAME derived data
                            onChange((filtersPrev) => ({
                              ...filtersPrev,
                              propertyAmenities: nextSelected.map(
                                (item) => item.UnitFurnishingID,
                              ),
                            }));

                            return nextSelected;
                          });
                        }}
                      />
                      <label htmlFor="Lift">{type?.UnitFurnishing}</label>
                    </div>
                  ))}
                  <a
                    style={{ cursor: "pointer", color: "#1e88e5" }}
                    onClick={() => setShowAllunitfurnish((prev) => !prev)}
                  >
                    {showAllunitfurnish ? "View Less" : "View More"}
                  </a>
                </div>
              </>
            )}


<div className="bottombtn d-mobile">
     <a className="btn style1">Apply Filter</a>
</div>

          {/* <div className="fblock">
            <strong>Posted By</strong>
            <div className="d-block">
              <input
                type="checkbox"
                id="Owner"
                name="Owner"
                value="Verified Owner"
              />
              <label htmlFor="Owner">Verified Owner</label>
            </div>
            <div className="d-block">
              <input
                type="checkbox"
                id="Agent"
                name="Agent"
                value="Verified Agent"
              />
              <label htmlFor="Agent">Verified Agent</label>
            </div>
            <div className="d-block">
              <input
                type="checkbox"
                id="Builder"
                name="Builder"
                value="Builder"
              />
              <label htmlFor="Builder">Builder</label>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default SidebarFilter;
